import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

/**
 * Per-brand display filters for brand single step paths.
 *
 * Create and delete go through this route because the backend owns the filter audience's lifecycle;
 * editing the filter values afterwards is a plain AudienceService update on the nested audience.
 */
@Injectable()
export class SingleStepFilterService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'single_step_filters');
  }
}
